import { render, staticRenderFns } from "./ValidarCertificado.vue?vue&type=template&id=59142dfb&scoped=true"
import script from "./ValidarCertificado.vue?vue&type=script&lang=js"
export * from "./ValidarCertificado.vue?vue&type=script&lang=js"
import style0 from "./ValidarCertificado.vue?vue&type=style&index=0&id=59142dfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59142dfb",
  null
  
)

export default component.exports